import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { Snackbar, SnackbarContent, IconButton, Box, Paper, } from '@material-ui/core';
import { makeStyles, alpha } from '@material-ui/core/styles';
import { getBackgroundColorByTheme, getTextColorByTheme } from '../../design/AlertVariants';
import { TypeWidgetHeader } from '../Typography';
import { CheckCircleIcon, CloseIcon } from '../Icon';
const TESTID_ROOT = 'snack-card';
export const testids = {
    banner: TESTID_ROOT,
    content: [TESTID_ROOT, 'content'].join(':'),
    alert: [TESTID_ROOT, 'alert'].join(':'),
    closeBtn: [TESTID_ROOT, 'close-btn'].join(':'),
};
const useStyles = makeStyles((theme) => ({
    root: {
        [theme.breakpoints.up('sm')]: {
            maxWidth: theme.spacing(46),
        },
    },
    wrapper: {
        overflow: 'hidden',
        width: '100%',
    },
    title: ({ variant }) => ({
        backgroundColor: getBackgroundColorByTheme(theme, variant),
        borderRadius: 0,
        flexWrap: 'nowrap',
    }),
    icon: {
        fontSize: 20,
        marginRight: theme.spacing(1.5),
    },
    closeIcon: {
        flexShrink: 0,
    },
    message: ({ variant }) => ({
        display: 'flex',
        alignItems: 'center',
        backgroundColor: getBackgroundColorByTheme(theme, variant),
    }),
    content: ({ variant }) => ({
        backgroundColor: alpha(getBackgroundColorByTheme(theme, variant), 0.1),
        padding: theme.spacing(2, 2.5),
    }),
    textColor: ({ variant }) => ({
        color: getTextColorByTheme(theme, variant),
    }),
}));
export const SnackCard = (_a) => {
    var { variant = 'success', title, children, onClose, titleProps, contentClassName } = _a, props = __rest(_a, ["variant", "title", "children", "onClose", "titleProps", "contentClassName"]);
    const classes = useStyles({ variant });
    return (_jsx(Snackbar, Object.assign({ "data-testid": testids.banner, className: classes.root, anchorOrigin: {
            horizontal: 'right',
            vertical: 'bottom',
        } }, props, { children: _jsxs(Paper, Object.assign({ className: classes.wrapper, elevation: 6 }, { children: [_jsx(SnackbarContent, Object.assign({ "data-testid": testids.content, "aria-describedby": testids.alert, 
                    // remove elevation in favor of wrapper elevation
                    elevation: 0, message: _jsxs(Box, Object.assign({ className: classes.message }, { children: [_jsx(CheckCircleIcon, { className: classes.icon }, void 0),
                            _jsx(TypeWidgetHeader, Object.assign({ "data-testid": testids.alert, id: testids.alert, classes: { root: classes.textColor } }, { children: title }), void 0)] }), void 0), action: [
                        _jsx(IconButton, Object.assign({ "aria-label": "close", color: "inherit", className: classes.closeIcon, onClick: onClose, "data-testid": testids.closeBtn }, { children: _jsx(CloseIcon, {}, void 0) }), "close"),
                    ] }, titleProps, { 
                    // pass className after custom props to merge all classes
                    className: clsx(classes.title, titleProps === null || titleProps === void 0 ? void 0 : titleProps.className) }), void 0),
                _jsx(Box, Object.assign({ className: clsx(classes.content, contentClassName) }, { children: children }), void 0)] }), void 0) }), void 0));
};
//# sourceMappingURL=SnackCard.js.map